import { useEffect, useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";

import Banner from "../banner/banner";
import Page from "../page/page";
import ReactGA from "react-ga4";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import "./AdminPage.scss";
import classNames from "classnames";
import { checkAllowedToBuyNewTokens } from "../OrderSuccessPage/OrderSuccessPage";
import { generateCode } from "../services/api";

const AdminPage = () => {
  const navigate = useNavigate();

  const [allEvents, setAllEvents] = useState([]);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  // const initialCheck = async () => {
  //   const existingCode = window.localStorage.getItem("shotamCode");
  //   if (existingCode) {
  //     const allowedToBuy = await checkAllowedToBuyNewTokens(existingCode);
  //     if (!allowedToBuy) {
  //       navigate("/order");
  //     } else {
  //       window.localStorage.removeItem("shotamCode");
  //     }
  //   }
  // };

  // useEffect(() => {
  //   const storedName = window.localStorage.getItem("shotamPseudo");
  //   if (storedName) {
  //     setName(storedName);
  //     if (storedName.length >= 3) {
  //       setCurrentStep(1);
  //     }
  //   }
  //   initialCheck();
  //   // fetch(
  //   //   `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/events`,
  //   // )
  //   //   .then((res) => {
  //   //     res.json().then((events) => {
  //   //       // console.log(events);
  //   //       // setAllEvents(events.documents);
  //   //       // setAllCities(
  //   //       //   events.documents
  //   //       //     .map((event) => event.fields.city.stringValue)
  //   //       //     .filter((city, index, array) => array.indexOf(city) === index),
  //   //       // );
  //   //     });
  //   //   })
  //   //   .catch(() => {});
  // }, []);

  const askCode = () => {
    const code = generateCode();
    setCode(code);
  };

  return (
    <>
      <Page>
        <div className="buyingStep">
          <div className="stepNumber">+</div>
          <div className="stepTitle">Rehydration</div>
          <button className="codeGenerator" onClick={askCode}>
            Générer un code
          </button>
          {code ? <div className="code">{code}</div> : <></>}
        </div>
      </Page>
    </>
  );
};

export default AdminPage;
